// extracted by mini-css-extract-plugin
module.exports = {"ldsRipple":"loader-module__ldsRipple___fRDRV","lds-ripple":"loader-module__lds-ripple___CbP+I"};